import React from "react";
import { InfoCircleFill } from "react-bootstrap-icons";

import Tooltip from "components/ui/tooltip/CustomTooltip";

interface Props {
  label: string;
  labelDesc?: string;
  isRequired?: boolean;
  hint?: string;
  hintId?: string;
  className?: string
  isLabelInline?: boolean
}

const FormLabel = ({ label, labelDesc, isRequired, hint, hintId, className, isLabelInline }: Props) => {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <label className={`d-flex flex-column ${isLabelInline ? '' : 'mb-2'}`}>
        <div>
          <span className="form-label fw-bold">
            {label} {isRequired && "*"}
          </span>
          {hint && hintId && (
            <span>
              <span data-tooltip-id={hintId} className="f-s-12 text-muted ms-2">
                <InfoCircleFill size={12} />
              </span>
              <Tooltip id={hintId}>
                <div className="fw-normal">{hint}</div>
              </Tooltip>
            </span>
          )}
        </div>
        <span className="f-s-14 label-desc-color">{labelDesc}</span>
      </label>
    </div>
  );
};

export default FormLabel;
